import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { isVideoMedia } from '../utils/media';

const SponsorCard = ({ sponsor, index = 0 }) => {
  const link = sponsor.website || sponsor.instagram;
  const bannerIsVideo = isVideoMedia(sponsor.image_url, sponsor.image_media_type);

  return (
    <motion.div
      data-testid={`sponsor-card-${sponsor.id}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="card group overflow-hidden"
    >
      {/* Image */}
      <div className="relative h-48 overflow-hidden bg-[#1C1C1C]">
        {sponsor.image_url ? (
          bannerIsVideo ? (
            <video
              src={sponsor.image_url}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
            />
          ) : (
            <img
              src={sponsor.image_url}
              alt={sponsor.name}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
          )
        ) : sponsor.logo_url ? (
          <div className="w-full h-full flex items-center justify-center p-8">
            <img
              src={sponsor.logo_url}
              alt={sponsor.name}
              className="max-w-full max-h-full object-contain"
            />
          </div>
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <span className="font-['Oswald'] text-4xl text-[#2A2A2A]">
              {sponsor.name.charAt(0)}
            </span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent opacity-60" />
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="font-['Oswald'] text-xl text-[#F2EDE6] mb-3 group-hover:text-[#E8651A] transition-colors">
          {sponsor.name}
        </h3>

        {sponsor.description && (
          <p className="text-[#A19D98] text-sm mb-4 line-clamp-3">
            {sponsor.description}
          </p>
        )}

        {link && (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`sponsor-link-${sponsor.id}`}
            className="btn-secondary w-full flex items-center justify-center gap-2 text-sm"
          >
            Visit
            <ExternalLink size={14} />
          </a>
        )}
      </div>
    </motion.div>
  );
};

export default SponsorCard;
